import { InputOTP, InputOTPGroup, InputOTPSlot } from '../ui/input-otp';

type TOTPProps = {
  value: string;
  setValue: (value: string) => void;
};

const OTP = ({ value, setValue }: TOTPProps) => (
  <InputOTP value={value} onChange={(value) => setValue(value)} maxLength={6}>
    <InputOTPGroup>
      <InputOTPSlot index={0} />
      <InputOTPSlot index={1} />
      <InputOTPSlot index={2} />
    </InputOTPGroup>
    <InputOTPGroup>
      <InputOTPSlot index={3} />
      <InputOTPSlot index={4} />
      <InputOTPSlot index={5} />
    </InputOTPGroup>
  </InputOTP>
);

export default OTP;
